import { getOne } from "../db";

export const ACCOUNT = ["authentication", "currentUser"];

// Account
export const checkedAuthentication = (props) =>
  getOne(["authentication"], "checked", props);

export const userId = (props) => getOne(["authentication"], "userId", props);
